"use client"

import React from 'react'
import { ShieldAlert } from 'lucide-react'

/**
 * Banner displayed when an entire section of PII fields is restricted
 * for the current user. Used in place of PII form fields when the user
 * doesn't have contextual access (wrong region, outside trip window, etc.).
 */
export function RestrictedPiiSection({
    sectionName = 'This section',
}: {
    sectionName?: string
}) {
    return (
        <div className="flex items-start gap-3 rounded-lg border border-amber-200/60 bg-amber-50/50 dark:border-amber-800/40 dark:bg-amber-950/20 p-3 text-sm text-amber-800 dark:text-amber-200">
            <ShieldAlert className="h-4 w-4 mt-0.5 shrink-0 text-amber-600 dark:text-amber-400" />
            <div>
                <p className="font-medium">{sectionName} contains restricted information</p>
                <p className="mt-0.5 text-amber-700/80 dark:text-amber-300/70 text-xs">
                    Access is limited to authorized personnel during active trip windows.
                    Contact an administrator if you believe you should have access.
                </p>
            </div>
        </div>
    )
}
